import { hot } from 'react-hot-loader/root'
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import LayoutContainer from './LayoutContainer'
import HomeContainer from '../modules/Home/containers/HomeContainer'
import {
    UsersListContainer,
    UsersCreateContainer,
    UsersEditContainer,
    UsersShowContainer,
    UsersScheduleContainer,
} from '../modules/Users'
import {
    CustomersSearchContainer,
    CustomersCreateContainer,
    CustomersEditContainer,
} from '../modules/Customers/containers'
import {
    ProductsListContainer,
    ProductsShowContainer,
    ProductsCreateContainer,
    ProductsEditContainer,
    ProductsRecordContainer,
} from '../modules/Products'
import {
    SubsidiariesListContainer,
    SubsidiariesCreateContainer,
    SubsidiariesEditContainer,
    SubsidiariesShowContainer,
} from '../modules/Subsidiaries'
import {
    WarehousesListContainer,
    WarehousesCreateContainer,
    WarehousesEditContainer,
} from '../modules/Warehouses/containers'
import { BrandsListContainer, BrandsCreateContainer, BrandsEditContainer, BrandsShowContainer } from '../modules/Brands'
import {
    MeasureUnitListContainer,
    MeasureUnitCreateContainer,
    MeasureUnitEditContainer,
    MeasureUnitShowContainer,
} from '../modules/MeasureUnit'
import {
    InventoryEntryContainer,
    InventoryEntryReport,
    InventoryTransferContainer,
} from '../modules/Inventory/containers'
import {
    ReportInventoryContainer,
    ReportCreditContainer,
    ShiftsReportContainer,
    ReportAssistancesGeneralContainer,
    ReportAssistancesWeeklyContainer,
    ReportSalesContainer,
    ReportOrdersShowContainer,
    ReportOrdersPaymentContainer,
    ReportCashdrawalContainer,
    CashdrawalShowContainer,
    CashdrawalReasonCreate,
    CashdrawalReasonsContainer
} from '../modules/Reports/containers'
import {
    DiscountsListContainer,
    DiscountsCreateContainer,
    DiscountsEditContainer,
    DiscountsShowContainer,
} from '../modules/Discounts/containers'
import {
    CustomerTypesListContainer,
    CustomerTypesEditContainer,
    CustomerTypesCreateContainer,
    CustomerTypesShowContainer,
} from '../modules/CustomerTypes'
import {
    CategoriesListContainer,
    CategoriesEditContainer,
    CategoriesCreateContainer,
    CategoriesShowContainer,
} from '../modules/Categories'
import {
    ProductTypesListContainer,
    ProductTypesEditContainer,
    ProductTypesCreateContainer,
    ProductTypesShowContainer,
} from '../modules/ProductTypes'

import CheckoutsListContainer from '../modules/Checkouts/CheckoutsListContainer'
import CheckoutsCreateContainer from '../modules/Checkouts/CheckoutsCreateContainer'
import CheckoutsEditContainer from '../modules/Checkouts/CheckoutsEditContainer'
import CheckoutsShowContainer from '../modules/Checkouts/CheckoutsDetalleContainer'
import TokenContainer from '../modules/Token/TokenContainer'

import {
    SatCodeListContainer,
    SatCodeEditContainer,
    SatCodeCreateContainer,
    SatCodeShowContainer,
} from '../modules/SatCodeServices'
import { InvoicesListContainer } from '../modules/Invoices'

const routes = [
    {
        exact: true,
        path: '/home',
        component: HomeContainer,
    },
    {
        exact: true,
        path: '/users',
        component: UsersListContainer,
    },
    {
        exact: true,
        path: '/users/create',
        component: UsersCreateContainer,
    },
    {
        exact: true,
        path: '/users/edit/:id',
        component: UsersEditContainer,
    },
    {
        exact: true,
        path: '/users/show/:id',
        component: UsersShowContainer,
    },

    {
        exact: true,
        path: '/users/schedule/:id',
        component: UsersScheduleContainer,
    },
    {
        exact: true,
        path: '/customers',
        component: CustomersSearchContainer,
    },
    {
        exact: true,
        path: '/customers/create',
        component: CustomersCreateContainer,
    },
    {
        exact: true,
        path: '/customers/edit/:id',
        component: CustomersEditContainer,
    },
    {
        exact: true,
        path: '/customer_types',
        component: CustomerTypesListContainer,
    },
    {
        exact: true,
        path: '/customer_types/create',
        component: CustomerTypesCreateContainer,
    },
    {
        exact: true,
        path: '/customer_types/edit/:id',
        component: CustomerTypesEditContainer,
    },
    {
        exact: true,
        path: '/customer_types/show/:id',
        component: CustomerTypesShowContainer,
    },
    {
        exact: true,
        path: '/categories',
        component: CategoriesListContainer,
    },
    {
        exact: true,
        path: '/categories/create',
        component: CategoriesCreateContainer,
    },
    {
        exact: true,
        path: '/categories/edit/:id',
        component: CategoriesEditContainer,
    },
    {
        exact: true,
        path: '/categories/show/:id',
        component: CategoriesShowContainer,
    },

    {
        exact: true,
        path: '/products',
        component: ProductsListContainer,
    },

    //subcategories
    {
        exact: true,
        path: '/subcategories',
        component: ProductTypesListContainer,
    },
    {
        exact: true,
        path: '/subcategories/edit/:id',
        component: ProductTypesEditContainer,
    },
    {
        exact: true,
        path: '/subcategories/show/:id',
        component: ProductTypesShowContainer,
    },

    {
        exact: true,
        path: '/subcategories/create',
        component: ProductTypesCreateContainer,
    },

    {
        exact: true,
        path: '/productTypes',
        component: ProductTypesListContainer,
    },
    {
        exact: true,
        path: '/productTypes/edit/:id',
        component: ProductTypesEditContainer,
    },
    {
        exact: true,
        path: '/productTypes/create',
        component: ProductTypesCreateContainer,
    },
    //Products
    {
        exact: true,
        path: '/products/create',
        component: ProductsCreateContainer,
    },
    {
        exact: true,
        path: '/products/edit/:id',
        component: ProductsEditContainer,
    },
    {
        exact: true,
        path: '/products/show/:id',
        component: ProductsShowContainer,
    },
    {
        exact: true,
        path: '/products/record/:id',
        component: ProductsRecordContainer,
    },

    {
        exact: true,
        path: '/subsidiaries',
        component: SubsidiariesListContainer,
    },
    {
        exact: true,
        path: '/subsidiaries/create',
        component: SubsidiariesCreateContainer,
    },
    {
        exact: true,
        path: '/subsidiaries/edit/:id',
        component: SubsidiariesEditContainer,
    },
    {
        exact: true,
        path: '/subsidiaries/show/:id',
        component: SubsidiariesShowContainer,
    },
    {
        exact: true,
        path: '/warehouses',
        component: WarehousesListContainer,
    },
    {
        exact: true,
        path: '/warehouses/create',
        component: WarehousesCreateContainer,
    },
    {
        exact: true,
        path: '/warehouses/edit/:id',
        component: WarehousesEditContainer,
    },
    //Brands
    {
        exact: true,
        path: '/brands',
        component: BrandsListContainer,
    },
    {
        exact: true,
        path: '/brands/create',
        component: BrandsCreateContainer,
    },
    {
        exact: true,
        path: '/brands/edit/:id',
        component: BrandsEditContainer,
    },
    {
        exact: true,
        path: '/brands/show/:id',
        component: BrandsShowContainer,
    },
    {
        exact: true,
        path: '/measure_units',
        component: MeasureUnitListContainer,
    },
    {
        exact: true,
        path: '/measure_units/create',
        component: MeasureUnitCreateContainer,
    },
    {
        exact: true,
        path: '/measure_units/edit/:id',
        component: MeasureUnitEditContainer,
    },
    {
        exact: true,
        path: '/measure_units/show/:id',
        component: MeasureUnitShowContainer,
    },
    {
        exact: true,
        path: '/inventory/entry',
        component: InventoryEntryContainer,
    },
    {
        exact: true,
        path: '/inventory/list',
        component: InventoryEntryReport,
    },
    {
        exact: true,
        path: '/inventory/transfer',
        component: InventoryTransferContainer,
    },
    {
        exact: true,
        path: '/report/inventory',
        component: ReportInventoryContainer,
    },
    {
        exact: true,
        path: '/orders/show/:id',
        component: ReportOrdersShowContainer,
    },
    {
        exact: true,
        path: '/orders/pay/:id',
        component: ReportOrdersPaymentContainer,
    },
    {
        exact: true,
        path: '/report/sales',
        component: ReportSalesContainer,
    },
    {
        exact: true,
        path: '/invoices',
        component: InvoicesListContainer,
    },
    {
        exact: true,
        path: '/report/credit',
        component: ReportCreditContainer,
    },
    {
        exact: true,
        path: '/report/assistances/weekly',
        component: ReportAssistancesWeeklyContainer,
    },
    {
        exact: true,
        path: '/report/assistances/general',
        component: ReportAssistancesGeneralContainer,
    },

    {
        exact: true,
        path: '/report/shifts',
        component: ShiftsReportContainer,
    },
    {
        exact: true,
        path: '/report/cash-withdrawal',
        component: ReportCashdrawalContainer,
    },
    {
        exact: true,
        path: '/report/cash-withdrawal-reasons',
        component: CashdrawalReasonsContainer,
    },
    {
        exact: true,
        path: '/cash-withdrawals/show/:id',
        component: CashdrawalShowContainer,
    },
    {
        exact: true,
        path: '/cash-withdrawal-reasons/create',
        component: CashdrawalReasonCreate,
    },
    {
        exact: true,
        path: '/discounts',
        component: DiscountsListContainer,
    },
    {
        exact: true,
        path: '/discounts/create',
        component: DiscountsCreateContainer,
    },
    {
        exact: true,
        path: '/discounts/edit/:id',
        component: DiscountsEditContainer,
    },
    {
        exact: true,
        path: '/discounts/show/:id',
        component: DiscountsShowContainer,
    },
    {
        exact: true,
        path: '/checkouts',
        component: CheckoutsListContainer,
    },
    {
        exact: true,
        path: '/checkouts/create',
        component: CheckoutsCreateContainer,
    },
    {
        exact: true,
        path: '/checkouts/show/:id',
        component: CheckoutsShowContainer,
    },

    {
        exact: true,
        path: '/checkouts/edit/:id',
        component: CheckoutsEditContainer,
    },

    {
        exact: true,
        path: '/token',
        component: TokenContainer,
    },
     {
        exact: true,
        path: '/sat_code',
        component: SatCodeListContainer,
    },
    {
        exact: true,
        path: '/sat_code/create',
        component: SatCodeCreateContainer,
    },
    {
        exact: true,
        path: '/sat_code/show/:id',
        component: SatCodeShowContainer,
    },

    {
        exact: true,
        path: '/sat_code/edit/:id',
        component: SatCodeEditContainer,
    },
]

class Root extends React.Component {
    render() {
        return (
            // eslint-disable-next-line react/jsx-fragments
            <React.Fragment>
                <LayoutContainer user={this.props.user}>
                    <main>
                        <Switch>
                            {routes.map(r => (
                                <Route
                                    key={r.path}
                                    exact={r.exact}
                                    path={r.path}
                                    render={props => <r.component {...props} user={this.props.user} />}
                                />
                            ))}
                        </Switch>
                    </main>
                </LayoutContainer>
            </React.Fragment>
        )
    }
}

export default hot(Root)
